<template>
    <nav id="navigation" :class="propPos-propHeight < 10 ? 'fixed pin-t bg-white sticky shadow' : 'relative'"
         class="w-full z-50 h-24 font-fira flex lg:justify-between justify-start items-center shadow srollmain">
        <div class="flex lg:flex-row flex-col lg:w-full items-center ml-6">
            <img class="w-32 w-24" src="../assets/visualz_landing_hero.png">
            <span class="hidden lg:block font-hairline text-5xl text-v-green ml-4">|</span>
            <h1 class="lg:text-3xl text-xl font-hairline lg:ml-2">Creative Studio</h1>
        </div>
        <div class="nav lg:w-auto lg:flex lg:mr-8 absolute lg:relative" v-if="!isMobile">
            <a v-scroll-to="{el: '.scrollabout',offset: -200,}"
               class="cursor-pointer inline-block p-2 mx-4 text-xl no-underline uppercase font-hairline bar bar1">Rólunk</a>
            <a v-scroll-to="{el: '.references',offset: -200,}"
               class="cursor-pointer inline-block p-2 mx-4 text-xl no-underline uppercase font-hairline bar bar2">Referenciák</a>
            <a v-scroll-to="{el: '.contactscroll',offset: -300,}"
               class="cursor-pointer inline-block p-2 px-4 text-xl no-underline uppercase font-hairline bar bar3">Kapcsolat</a>
        </div>
        <transition appear>
            <div class="nav absolute shadow-lg flex flex-col items-center justify-center bg-white" v-if="mobiletoggle">
                <a v-scroll-to="{el: '.scrollabout',offset: -200,}" @click="mobiletoggle = !mobiletoggle"
                   class="cursor-pointer inline-block p-4 mx-4 text-xl no-underline uppercase font-hairline">Rólunk</a>
                <a v-scroll-to="{el: '.references',offset: -70,}" @click="mobiletoggle = !mobiletoggle"
                   class="cursor-pointer inline-block p-4 mx-4 text-xl no-underline uppercase font-hairline">Referenciák</a>
                <a v-scroll-to="{el: '.contactscroll',offset: -100,}" @click="mobiletoggle = !mobiletoggle"
                   class="cursor-pointer inline-block p-4 pb-8 px-4 text-xl no-underline uppercase font-hairline">Kapcsolat</a>
            </div>
        </transition>

        <div v-if="isMobile" class="navbar-burger absolute" @click="mobiletoggle = !mobiletoggle">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </nav>

</template>

<script>
export default {
  props: ['propHeight', 'propPos', 'propWidth'],
  data () {
    return {
      hamburger: false,
      openMenu: false,
      menu: true,
      mobiletoggle: false
    }
  },
  watch: {
    propWidth () {
      this.menu = this.isMobile
    }
  },
  computed: {
    isMobile () {
      return (this.propWidth < 992)
    }
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu
    },
    menuone () {
    },
    menutwo () {
    },
    menuthree () {
    }
  }
}

</script>

<style lang="scss" scoped>
    nav {
        transition: height 0.5s;
    }

    .nav {
        @media (max-width: 576px) {
        }
        @media (max-width: 768px) {
        }
        @media (max-width: 992px) {
            bottom: -180px;
            right: 0px;
            display: flex;
            flex-direction: column;

        }
        @media (max-width: 1200px) {
        }
    }

    img {
        @media (min-width: 992px) {
            margin-left: 50px;

        }
    }

    .h-24.sticky {
        height: 4rem;
    }

    .navbar-burger {
        cursor: pointer;
        display: block;
        height: 3.25rem;
        position: relative;
        width: 3.25rem;
        margin-left: auto;
    }

    .navbar-burger span {
        background-color: currentColor;
        display: block;
        height: 1px;
        left: calc(50% - 8px);
        position: absolute;
        -webkit-transform-origin: center;
        transform-origin: center;
        -webkit-transition-duration: 86ms;
        transition-duration: 86ms;
        -webkit-transition-property: background-color, opacity, -webkit-transform;
        transition-property: background-color, opacity, -webkit-transform;
        transition-property: background-color, opacity, transform;
        transition-property: background-color, opacity, transform, -webkit-transform;
        -webkit-transition-timing-function: ease-out;
        transition-timing-function: ease-out;
        width: 16px;
    }

    .navbar-burger span:nth-child(1) {
        top: calc(50% - 6px);
    }

    .navbar-burger span:nth-child(2) {
        top: calc(50% - 1px);
    }

    .navbar-burger span:nth-child(3) {
        top: calc(50% + 4px);
    }

    .navbar-burger:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .navbar-burger.is-active span:nth-child(1) {
        -webkit-transform: translateY(5px) rotate(45deg);
        transform: translateY(5px) rotate(45deg);
    }

    .navbar-burger.is-active span:nth-child(2) {
        opacity: 0;
    }

    .navbar-burger.is-active span:nth-child(3) {
        -webkit-transform: translateY(-5px) rotate(-45deg);
        transform: translateY(-5px) rotate(-45deg);
    }

    .bar {
        position: relative;
    }

    .bar:before,
    .bar:after {
        content: '';
        height: 1px;
        width: 0;
        bottom: 1px;
        position: absolute;
        transition: 0.2s ease all;
    }

    .bar:before {
        left: 50%;
    }

    .bar:after {
        right: 50%;
    }

    .bar:hover:after,
    .bar:hover:before {
        width: 50%;
    }

    .bar1:before,
    .bar1:after {
        background: rgb(57, 82, 136);
    }

    .bar2:before,
    .bar2:after {
        background: rgb(227, 182, 36);
    }

    .bar3:before,
    .bar3:after {
        background: rgb(184, 31, 118);
    }

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue